export default "__VITE_PUBLIC_ASSET__a5d14a1e__"